import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from './index';

const styles = () => ({
  root: {
    border: '2px solid teal',
  },
});

const OutlineBox = ({
  classes,
  className,
  ...rest
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      <Box
        classes={classes}
        {...rest}
      />
    </div>
  );
};

OutlineBox.propTypes = {
  classes: PropTypes.string.isRequired,
  className: PropTypes.string,
};
OutlineBox.defaultProps = {
  className: '',
};

export default withStyles(styles)(OutlineBox);
